"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function toArray(collection) {
    return [].slice.call(collection);
}
exports.default = toArray;
//# sourceMappingURL=toArray.js.map